import axios from "axios";
import { MessagePlugin } from "tdesign-vue";
const instance = axios.create({
    timeout: 30000,
});

instance.interceptors.request.use(
    function (config) {
        let lang = navigator.language.replace(/-/g, "");
        config.headers.Language = lang == "zhCN" ? "zhCN" : "en";
        let token = localStorage.getItem("v7token");
        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    function (response) {
        if (response.data.code == 401) {
            MessagePlugin.error("登录过期，请重新登录");
            window.location.href = "/login";
            return;
        }
        return response.data;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default instance;
